__turbopack_context__.v({
  "container": "ProductHeading-module__95ysbW__container",
  "description": "ProductHeading-module__95ysbW__description",
});
